import './App.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Landingpage from './Components/Landingpage/Landingpage';
import ApplyInternship from './Components/Applyinternship/Apply';
import Scrolltotop from './Components/Scrolltotop';
import Legal from "./Components/Legal/Legal";
import Portfolio from './Components/Portfolio/Portfolio';





function App() {
  return (
    <BrowserRouter>

<Scrolltotop/>

    <Routes>
      <Route path="/" element={<Landingpage/>} />

        <Route
          path="/apply-internship"
          element={<ApplyInternship />}
        />
                  <Route
                        path="/privacy-policy"
                        element={<Legal />}
                    />

                    <Route
                        path="/terms-and-conditions"
                        element={<Legal />}
                    />

                    <Route
                        path="/portfolio"
                        element={<Portfolio />}
                    />

                   

           

  

    </Routes>

  </BrowserRouter>

  );
}

export default App;
